export default __webpack_public_path__ + "static/media/girls.3699666d.png";